goog.provide('el8.appchart.init.mainFeeds');

goog.require('el8.appchart.mainFeeds.chart');
goog.require('el8.appchart.mainFeeds.chartFileUploader');
goog.require('el8.appchart.mainFeeds.outstanding');
goog.require('el8.appchart.mainFeeds.reqAct');
goog.require('el8.appshared.dialog.imagesZoom');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.fetch');
goog.require('el8.ptdata.pmpCheckNotifications');


el8.appchart.init.mainFeeds = function() {

    var that = this;
    // if chrono sort feature is on, then by default we sort by patient activity, not provider.
    // otherwise, we sort by porivder activity by default.

    this._sortByProviderActivity = (el8.data.practiceSettings.getPatientChartSortStr() === 'provider') ? true : false;

    this.setSortByProviderActivity = function(byProviderActivity) {
        that._sortByProviderActivity = byProviderActivity;
        el8.appchart.mainFeeds.chart._sortByProviderActivity = byProviderActivity;

        if (that._sortByProviderActivity) {
            $('#chart-feed-sort-menu-trigger').html("Provider Activity Dates &#9662;");
        }
        else {
            $('#chart-feed-sort-menu-trigger').html("Patient Event Dates &#9662;");
        }
    };

    // Make sure the outer requiring actions container gets shown/hidden
    // appropriately for reqActFeed and outstandingFeed
    function updateReqActContainer() {
        if (el8.appchart.mainFeeds.reqAct.isIndexLoaded() && el8.appchart.mainFeeds.reqAct.isEmpty() &&
            el8.appchart.mainFeeds.outstanding.isIndexLoaded() && el8.appchart.mainFeeds.outstanding.isEmpty()) {
            $('#req-action-container').hide();
            $('#req-action-empty').show();
        } else {
            $('#req-action-empty').hide();
            $('#req-action-container').show();
        }
    }
    el8.appchart.mainFeeds.chart.bind('render', updateChartContainer);
    el8.appchart.mainFeeds.reqAct.bind('render', updateReqActContainer);
    el8.appchart.mainFeeds.outstanding.bind('render', updateReqActContainer);

    function updateChartContainer() {
        if (el8.appchart.mainFeeds.chart.isIndexLoaded() && el8.appchart.mainFeeds.chart.isEmpty()) {
            $('#chart-section-header').hide();
        }
        else {
            $('#chart-section-header').show();
        }
    }

    this.setupMainChartContainer = function() {

        // setting up the sort order UI for chronological sort by patient or provider activities
        var sortTriggerSelector = '#chart-feed-sort-menu-trigger';
        var $sortTrigger = $(sortTriggerSelector);
        var $container = $("#chart-feed-container");
        if (!that._sortOrderMenu) {
            that._sortOrderMenu = new el8.uiwidget.NewActionsMenu({
                container: $container,
                anchorTop: $container,
                menuId: 'chart-feed-sort-menu',
                offsets: { top: 21, left: 0 },
                width: 160
            });

            $(document).on('click', sortTriggerSelector, function(e) {
                that._sortOrderMenu.display($sortTrigger,
                                    null,
                                    {top: 17, left: 10}, [
                                    {
                                        actionText : "Provider Activity Dates",
                                        actionFn : function() {
                                            that.setSortByProviderActivity(true);
                                            el8.appchart.mainFeeds.chart.update();
                                        }
                                    },
                                    {
                                        actionText : "Patient Event Dates",
                                        actionFn : function() {
                                            that.setSortByProviderActivity(false);
                                            el8.appchart.mainFeeds.chart.update();
                                        }
                                    }
                                    ]);
            });
        }
        that.setSortByProviderActivity(that._sortByProviderActivity);
    };

    el8.appchart.mainFeeds.chart.bind('render', this.setupMainChartContainer);
    $(document).on('click', '.refresh-req-action-trigger',  function() {
        el8.appchart.mainFeeds.reqAct.update();
        el8.appchart.mainFeeds.outstanding.update();
    });

    $(document).on('click', '.refresh-chart-feed-trigger',  function() {
        el8.appchart.mainFeeds.chart.update();
        if (el8Globals.FEATURES.PLR) {
            el8.appchart.mainFeeds.plrNotification.refresh();
        }
    });

    el8.ptdata.medOrders.bind('all', function(eventName, arg) {
        if (eventName === EVENTS.DELETED && (arg && arg instanceof el8_Entity)) {
            if (arg.isSignedOff()) {
                el8.appchart.mainFeeds.chart.remove(arg);
            } else {
                el8.appchart.mainFeeds.reqAct.remove(arg);
            }
        } else if (arg && arg instanceof el8_Entity) {
            el8.appchart.mainFeeds.chart.refreshItem(arg);
            el8.appchart.mainFeeds.reqAct.refreshItem(arg);
        }

        // Always refresh the feeds (might have a fulfillment error come in which sends an
        // "update" event and also exists in both the RA and main feeds)
        el8.appchart.mainFeeds.chart.update();
        el8.appchart.mainFeeds.reqAct.update();
    });
    el8.ptdata.dcMedOrders.bind('all', function(eventName, arg) {
        if (eventName === EVENTS.CREATED || eventName === EVENTS.DELETED ||
                !arg || !(arg instanceof el8_Entity)) {
            el8.appchart.mainFeeds.chart.update();
        } else if (arg && arg instanceof el8_Entity) {
            el8.appchart.mainFeeds.chart.refreshItem(arg);
        }
    });
    el8.ptdata.denialMedOrders.addItemObserver(function(item) {
        el8.appchart.mainFeeds.chart.refreshItem(item);
    });
    el8.ptdata.denialMedOrders.addObserver(function() {
        el8.appchart.mainFeeds.chart.update();
    });
    el8.ptdata.rxRefillRequests.addObserver(function() {
        el8.appchart.mainFeeds.reqAct.update();
    });
    el8.ptdata.visitNotes.bind('all', function(eventName, visit) {
        // always update reqact just in case (signed visits can be reqact as failed bills)
        el8.appchart.mainFeeds.reqAct.update();

        if (visit && visit.isSignedOff()) {
            if (eventName === EVENTS.DELETED) {
                el8.appchart.mainFeeds.chart.remove(visit.getId());
            } else {
                // visit edits can change their chart feed date,
                // so the feed order might be shifted
                el8.appchart.mainFeeds.chart.update();
            }
        } else {
            // in case this is just an action on the whole set
            el8.appchart.mainFeeds.chart.update();
        }
    });

    /**
     * Handler to force updating billing data in el8 cache when saving from Bill 2.0
     * Refreshes the legacy visit note bill summary or chart feed when the billing data has updated
     * @param {string} messengerEvent - 'VisitNoteBillingDataRefresh'
     * @param {callback} anonymous - callback function to execute when the event is triggered
     * callback @param {object} message - message object with payload
     */
    el8React.messenger.on('VisitNoteBillingDataRefresh', function(message) {
        var visitNoteId = message.payload.visitNoteId;
        var note = el8.ptdata.visitNotes.getById(visitNoteId);
        var billingInfoUpdated = message.payload.billingInfoUpdated;
        if (!note || !billingInfoUpdated) { return; }
        note.setBillFromSpec(billingInfoUpdated)
        if (note.getSignDate()) {
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.chart.update();
        } else {
            el8.appchart.mgr.notes.onBillUpdate(visitNoteId);

        }
    });

    el8.ptdata.visitNotes.addRealtimeObserver(function(id, action) {
        if (action === 'BILL_UPDATED') {
            var note = el8.ptdata.visitNotes.getById(id);
            if (!note) { return; }
            note.fetchBill({
                successCb: function() {
                    if (note.getSignDate()) {
                        el8.appchart.mainFeeds.reqAct.update();
                        el8.appchart.mainFeeds.chart.update();
                    } else {
                        el8.appchart.mgr.notes.onBillUpdate(id);
                    }
                }
            });
        }
        if (action === 'CREATED') {
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.chart.update();
        }
    });

    el8.ptdata.nonvisitNotes.bind('all', function(eventName, nonvisit) {
        el8.appchart.mainFeeds.reqAct.update();
        if (!nonvisit || nonvisit.isSignedOff()) {
            if (eventName === EVENTS.DELETED) {
                el8.appchart.mainFeeds.chart.remove(nonvisit.getId());
            } else {
                el8.appchart.mainFeeds.chart.update();
            }
        }
    });

    el8.ptdata.rxHistoryDownloadSummaries.bind('all', function(eventName, arg) {
        if (arg) {
            el8.appchart.mainFeeds.outstanding.update();
            // arg might be an id if it's a realtime update - right now those are always unsigned
            if ((arg instanceof el8_Entity) && arg.isSignedOff()) {
                el8.appchart.mainFeeds.chart.update();
            } else {
                el8.appchart.refpanel.meds.refreshAll();
            }
        }
    });

    el8.ptdata.reports.bind('all', function(eventName, arg, arg2, arg3) {

        if (eventName === EVENTS.MOVED || eventName === EVENTS.UPDATED) {  // MOVED is change category
            el8.appchart.mainFeeds.chart.refreshItem(arg);
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.outstanding.update();

        } else if (eventName === EVENTS.DELETED) {
            el8.appchart.mainFeeds.chart.remove(arg.getId());
            var fromReceiptId = arg.getFromLetterReceiptId();
            if (fromReceiptId) {
                // we just changed a LetterReceipt in the feed by deleting this report
                var receipt = el8.ptdata.letterReceipts.getById(fromReceiptId);
                if (receipt) {
                    // receipt isn't cached -> we haven't rendered it yet, so we can skip this work
                    receipt.markReportUnfiled(arg.getId()); // surgical update rather than refresh-from-server
                    el8.appchart.mainFeeds.chart.refreshItem(fromReceiptId);
                }
            }
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.outstanding.update();

        } else if (eventName === EVENTS.MERGED) {

            var updatedReport = arg;
            var removedReport = arg2;

            el8.appchart.mainFeeds.chart.remove(removedReport.getId());
            el8.appchart.mainFeeds.chart.refreshItem(updatedReport);
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.outstanding.update();

        } else {
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.outstanding.update();
            el8.appchart.mainFeeds.chart.update();
        }

    });

    el8.ptdata.referralOrders.bind('all', function(eventName, referral) {
        // update both even on delete so that if we're a
        // referralletter that gets cleaned up as well
        el8.appchart.mainFeeds.reqAct.update();
        el8.appchart.mainFeeds.chart.update();
    });
    el8.util.consts.ORDER_TYPES.forEach(function(orderType) {
        if (orderType === 'referral') { return; } // we handled that one above

        var entitySet = el8.ptdata.getOrderSet(orderType);
        entitySet.bind('all', function(eventName, order) {
            if (order.isSignedOff()) {
                if (eventName === EVENTS.DELETED) {
                    el8.appchart.mainFeeds.chart.remove(order.getId());
                } else {
                    el8.appchart.mainFeeds.chart.update();
                }
            }
            el8.appchart.mainFeeds.outstanding.update();
            el8.appchart.mainFeeds.reqAct.update();
        });
    });

    el8.ptdata.letters.bind('all', function(eventName, letter) {
        if (eventName === EVENTS.DELETED) {
            if (letter && letter.isSignedOff()) {
                el8.appchart.mainFeeds.chart.remove(letter.getId());
            }
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.outstanding.update();
        } else if (eventName === EVENTS.CREATED){
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.outstanding.update();
            // sometimes 'letter' is null - we'll be conservative in those cases and update
            if (!letter || letter.isSignedOff()) {
                el8.appchart.mainFeeds.chart.update();
            }
        } else {
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.outstanding.update();
            if (letter.isSignedOff()) {
                el8.appchart.mainFeeds.chart.refreshItem(letter);
            }
        }
    });

    el8.ptdata.letterReceipts.bind('all', function(eventName, receipt) {
        if (eventName === EVENTS.DELETED) {
            el8.appchart.mainFeeds.chart.remove(receipt.getId());
        } else {
            el8.appchart.mainFeeds.chart.update();
        }
        el8.appchart.mainFeeds.outstanding.update();
        el8.appchart.mainFeeds.reqAct.update();
    });

    el8.ptdata.unreadLetterNotifications.bind('all', function(eventName, unreadNotification) {
        el8.appchart.mainFeeds.reqAct.update();
        el8.appchart.mainFeeds.chart.update();
    });

    el8.ptdata.plrCollaboratorNotifications.bind('all', function(eventName, unreadNotification) {
        el8.appchart.mainFeeds.reqAct.update();
        el8.appchart.mainFeeds.outstanding.update();
        el8.appchart.mainFeeds.chart.update();
    });

    el8.ptdata.vipAccessNotifications.bind('all', function(eventName, unreadNotification) {
        el8.appchart.mainFeeds.outstanding.update();
        el8.appchart.mainFeeds.chart.update();
    });

    el8.ptdata.pmpCheckNotifications.bind('all', function(eventName, notification) {
        if (eventName === EVENTS.DELETED) {
            el8.appchart.mainFeeds.reqAct.remove(notification.getId());
            el8.appchart.mainFeeds.chart.remove(notification.getId());
        } else {
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.chart.update();
        }
    });

    el8.ptdata.messageThreads.bind('all', function(eventName, thread) {
        if (thread.isSignedOff()) {
            el8.appchart.mainFeeds.chart.update();
        }
        el8.appchart.mainFeeds.outstanding.update();
        el8.appchart.mainFeeds.reqAct.update();
    });

    el8.ptdata.xmlSummaries.bind('all', function(eventName, summary) {
        if (eventName === EVENTS.DELETED) {
            el8.appchart.mainFeeds.reqAct.remove(summary.getId());
            el8.appchart.mainFeeds.chart.remove(summary.getId());
        } else {
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.chart.update();
        }
    });


    // If the vaccines section of the MagicTable is visible, refresh the table
    // whenever a ptImmunization(Decline) is created/updated/deleted
    var refreshMagicTableIfVisible = function() {
        if (el8.appchart.mainFeeds.chart.isMagicTableShowing()) {
            el8.appchart.mainFeeds.chart.refreshChartSearch();
        }
    };
    el8.ptdata.ptImmunizations.bind('all', function(eventName, ptImmunization) {
        refreshMagicTableIfVisible();
    });
    el8.ptdata.ptImmunizationDeclines.bind('all', function(eventName, decline) {
        refreshMagicTableIfVisible();
    });
    el8.ptdata.addendums.bind('all', function(eventName, addendum) {
        if (eventName === EVENTS.DELETED) {
            el8.appchart.mainFeeds.chart.remove(addendum.getId());
        } else {
            el8.appchart.mainFeeds.reqAct.update();
            el8.appchart.mainFeeds.chart.update();
        }
    });
    el8.ptdata.prenatalFlowsheetVisitMeasurements.bind('all', function(eventName, visitMeasurements) {
        if (eventName === EVENTS.DELETED) {
            el8.appchart.mainFeeds.chart.remove(visitMeasurements.getId());
        } else {
            el8.appchart.mainFeeds.chart.update();
        }
    });
    // Add ability to click to zoom in on images
    $('#chart-feed-container').on('click', '.zoomable',  function(e) {
        e.preventDefault();
        var item;
        var $this = $(this);
        var fid = $this.attr('_fid');
        var id = $this.data('id');
        if (fid) {
            item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
        } else if (id) {
            item = el8.ptdata.fetchById(id);
        }
        if (item) {
            el8.appshared.dialog.imagesZoom.show({
                images: item.getFullSizeImages ? item.getFullSizeImages() : []
            });
        }
    });

    // Setup drag and drop for patient summaries
    el8.appchart.mainFeeds.chartFileUploader.init();

};
